import dateFormatter from '@/services/formatter_services/date-formatter';
import dateService from '@/services/date-service';

const OVERVIEW_HEADER = Object.freeze([
  { text: 'Common.employee', value: 'employeeName' },
  { text: 'Common.type', value: 'attendanceType' },
  {
    text: 'Dashboard.widgets.sickNotes.headers.numberOfWorkingDays',
    value: 'numberOfWorkingDays'
  },
  {
    text: 'Common.start',
    value: 'startDate',
    presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
  },
  {
    text: 'Common.end',
    value: 'endDate',
    presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
  }
]);

const SICK_NOTES_WIDGETS = Object.freeze({
  SICK_NOTES_WIDGETS: [
    {
      id: 'sickNotes',
      path: 'sicknotes',
      getData: response => response.data.data?.map(item => item.data),
      headers: OVERVIEW_HEADER,
      type: 'TABLE',
      moduleId: 'sickNotes',
      withRouterActionLink: true
    },
    {
      id: 'sickNotesToday',
      path: 'sicknotes',
      defaultFilter: { startDate: dateService.getToday() },
      getData: response => response.data.data?.map(item => item.data),
      headers: OVERVIEW_HEADER,
      type: 'TABLE',
      moduleId: 'sickNotes',
      withRouterActionLink: true
    },
    {
      id: 'sickNotesMonth',
      path: 'sicknotes',
      defaultFilter: { startDate: dateService.getFirstDayOfCurrentMonth() },
      getData: response => response.data.data?.map(item => item.data),
      headers: OVERVIEW_HEADER,
      type: 'TABLE',
      moduleId: 'sickNotes',
      withRouterActionLink: true
    },
    {
      id: 'sickNotesAmount',
      path: 'sicknotes',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'sickNotes'
    },
    {
      id: 'sickNotesTodayAmount',
      path: 'sicknotes',
      defaultFilter: { startDate:  dateService.getToday() },
      getData: response => response.data.totalHits,
      type: 'VALUE',
      moduleId: 'sickNotes'
    },
    {
      id: 'sickNotesMonthAmount',
      path: 'sicknotes',
      defaultFilter: {  startDate: dateService.getFirstDayOfCurrentMonth() },
      getData: response => response.data.totalHits,
      type: 'VALUE',
      moduleId: 'sickNotes'
    },
  ]
});

export default SICK_NOTES_WIDGETS;
